import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { IBenefitCategory, IBenefitPackage } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateBenefitImplementations } from "./useGetBenefitImplementations";

type Params = {
  countryCode: number | string;
  benefitCategoryTag: number | string;
  clientInternalNumberGOS: number | string;
  benefitImplementationTag?: number | string;
  payload: IBenefitCategory;
};

const createBenefitPackage = async ({
  countryCode,
  benefitCategoryTag,
  clientInternalNumberGOS,
  benefitImplementationTag,
  payload,
}: Params): Promise<IBenefitPackage> => {
  const response = await api.post(
    `/benefitpackage/${countryCode}/${clientInternalNumberGOS}/${benefitCategoryTag}/${benefitImplementationTag}`,
    {
      ...payload,
    }
  );

  return response.data as IBenefitPackage;
};

export function useCreateBenefitPackage(refetch = true) {
  const queryClient = useQueryClient();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateBenefitImplementations =
    useInvalidateBenefitImplementations();

  return useMutation(createBenefitPackage, {
    mutationKey: MUTATION_KEYS.createBenefitPackage,
    onSuccess: () => {
      if (refetch) {
        invalidateBenefitImplementations();
        queryClient.refetchQueries({
          queryKey: QUERY_KEYS.benefitImplementationPackages,
        });
      }
      // queryClient.invalidateQueries({ queryKey: QUERY_KEYS.benefitCategories });
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
